import { Box } from "@mui/material";
import { useAppSelector } from "hooks/utilsHooks/storeHooks";
import { Fragment } from "react";
import { selectOrderSummary } from "slices/transactionSlice";
import { DishItemDisplayType } from "types/mainTypes";
import DishTypeItem from "../../dishTypeItem";
import { OrderDishDivider } from "./orderStepDrawerStyles";
import { StyledDishTypeList } from "./StyledDishTypeList";

// A fixed 750px height would push the discount code row rendered after the list off-screen.
export const OrderDishesList = ({
	smallOrderLimit,
	fitContent = false,
}: {
	smallOrderLimit: number;
	fitContent?: boolean;
}) => {
	const orderSummary = useAppSelector(selectOrderSummary);

	if (!orderSummary) {
		return null;
	}

	const { discountedDishTypes, fullPricedDishCounts, discountedDishCounts, orderDishTypesCount } = orderSummary;

	const isLargeOrder = orderDishTypesCount > smallOrderLimit;
	const hasMoreThanOneDishType = orderDishTypesCount > 1;

	return (
		<StyledDishTypeList
			// Explicit `height: auto`: the base `height: 100%` would stretch the list in a bounded wrapper.
			sx={
				fitContent
					? { height: "auto", maxHeight: "750px", paddingBottom: "30px" }
					: { height: "750px", paddingBottom: "30px" }
			}
			isLargeOrder={isLargeOrder}
			data-testid="overview-dish-list"
		>
			{discountedDishTypes &&
				discountedDishTypes.length > 0 &&
				discountedDishTypes.map((dishType) => (
					<Fragment key={`orderDiscountedDishTypeItem_${dishType.id}`}>
						<Box data-testid="overview-dish-row">
							<DishTypeItem
								dishType={dishType}
								type={DishItemDisplayType.ORDER}
								key={`order_item_${dishType.id}`}
								pieces={discountedDishCounts?.[dishType.id] || 0}
							/>
						</Box>
						{hasMoreThanOneDishType && <OrderDishDivider />}
					</Fragment>
				))}
			{orderSummary.orderDishTypes.map((dishType, index) => (
				<Fragment key={`orderDishTypeItem_${dishType.id}`}>
					<Box data-testid="overview-dish-row">
						<DishTypeItem
							dishType={dishType}
							type={DishItemDisplayType.ORDER}
							key={`order_item_${dishType.id}`}
							pieces={fullPricedDishCounts?.[dishType.id] || 0}
						/>
					</Box>
					{hasMoreThanOneDishType && index !== orderDishTypesCount - 1 && <OrderDishDivider />}
				</Fragment>
			))}
		</StyledDishTypeList>
	);
};
